import Vue from 'vue'
import router from './router/index.js'
import store from '@/store/index.js'
import App from './App'
import './permission' // 路由权限控制
import '@/utils/global'; // 原型挂载全局方法
import '@/lib/element'; // 按需加载
Vue.config.productionTip = false

new Vue({
	store,
	router,
	el: '#app',
	render: h => h(App)
})
